import { z } from 'zod/v3';

export const UserFollowedDataSubjectFormDataSchema = z.object({
  id: z.number(),
  dataSubjectId: z.number().optional(),
  dataSubject: z.string().optional(),
});
